module.exports = __webpack_public_path__ + "img/leagueoflegends-logo.fd1701b5.png";